import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';

interface AguardarAssinaturaParams {
  flowId: string;
  onConfirm: (data: any) => Promise<void>;
  onCreate?: (data: any) => Promise<void>;
}

interface UseWebSocketAssinaturaReturn {
  aguardarAssinatura: (params: AguardarAssinaturaParams) => Promise<void>;
}

export function useWebSocketAssinatura(): UseWebSocketAssinaturaReturn {
  const socketRef = useRef<Socket | null>(null);

  const aguardarAssinatura = async ({
    flowId,
    onConfirm,
    onCreate,
  }: AguardarAssinaturaParams): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      const socket = io(process.env.REACT_APP_WS_URL as string, {
        transports: ['websocket'],
      });

      socketRef.current = socket;

      socket.on('connect', () => {
        socket.emit('join-room', { room: flowId });
      });

      const handleConfirm = async (
        payload: any,
        callback?: (data: any) => void,
      ) => {
        callback?.({
          received: true,
          at: new Date().toISOString(),
        });

        try {
          await onConfirm(payload);
          socket.disconnect();
          resolve();
        } catch (err) {
          console.log(err);
          socket.disconnect();
          reject(err);
        }
      };

      socket.on('assinatura-confirmada', handleConfirm);
      socket.on('inclusao-associado', handleConfirm);

      socket.on('confirmation:created', async payload => {
        if (!onCreate) {
          return;
        }

        try {
          await onCreate(payload);
          socket.disconnect();
          resolve();
        } catch (err) {
          socket.disconnect();
          reject(err);
        }
      });

      socket.on('connect_error', err => {
        socket.disconnect();
        reject(err);
      });
    });
  };

  useEffect(() => {
    return () => {
      socketRef.current?.disconnect();
    };
  }, []);

  return { aguardarAssinatura };
}
